export { CriterionTypes, AnonymousCriterionTypes, ContentTypes, TargetTypes } from 'smart-content-core/constants';
export const DEFAULT_CRITERION_VALUE = null;
export const DragDropItemTypes = Object.freeze({
  CRITERION: 'CRITERION'
});